// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.login-text {
  color: #636363;
}

.font-normal {
  font-weight: normal;
  font-size: large;
}

.login-text {
  font-size: 1.1rem; /* Ajusta el tamaño de letra según sea necesario */
  margin-bottom: 1rem; /* Espaciado entre los textos */
}

.login-button {
  margin: 1rem 0; /* Espaciado entre los botones */
}

.azure-button, .white-font {
  font-size: 1rem; /* Ajusta el tamaño de letra de los botones */
}

.background {
  background-image: url('bkg_login.1bfc87d76a9f2d4b.png');
  background-size: cover;
  background-color: #f5f5f5;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  background-color: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.logo {
  max-width: 150px;
}

.login-text {
  margin: 0.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/login.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACA,cAAA;AACA;;AAEA;EACE,mBAAA;EACA,gBAAA;AACF;;AAIA;EACE,iBAAA,EAAA,kDAAA;EACA,mBAAA,EAAA,+BAAA;AADF;;AAKA;EACE,cAAA,EAAA,gCAAA;AAFF;;AAKA;EACE,eAAA,EAAA,6CAAA;AAFF;;AAMA;EACE,uDAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF","sourcesContent":["\n.login-text{\ncolor:#636363;\n}\n\n.font-normal{\n  font-weight: normal;\n  font-size:large;\n}\n\n\n\n.login-text {\n  font-size: 1.1rem; /* Ajusta el tamaño de letra según sea necesario */\n  margin-bottom: 1rem; /* Espaciado entre los textos */\n}\n\n\n.login-button {\n  margin: 1rem 0; /* Espaciado entre los botones */\n}\n\n.azure-button, .white-font {\n  font-size: 1rem; /* Ajusta el tamaño de letra de los botones */\n}\n\n\n.background {\n  background-image: url(\"./../../assets/images/bkg_login.png\") ;\n  background-size: cover;\n  background-color: #f5f5f5;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-box {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1rem;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.logo {\n  max-width: 150px;\n}\n\n.login-text {\n  margin: 0.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
